import { ContentListParams } from "@/types/content";

/** Ten rows is what the listings paginate at. */
export const CONTENT_PAGE_SIZE = 10;

/**
 * The paging query every managed-content listing shares.
 *
 * `sort=id,desc` puts the newest row first; without it Spring returns insertion
 * order, which buries a row the moment it is created. Verified against staging.
 */
export const buildContentQuery = (
  { page = 0, size = CONTENT_PAGE_SIZE }: ContentListParams = {},
  extra: Record<string, string | undefined> = {},
): URLSearchParams => {
  const params = new URLSearchParams({
    page: String(page),
    size: String(size),
    sort: "id,desc",
  });

  for (const [key, value] of Object.entries(extra)) {
    if (value !== undefined) params.set(key, value);
  }

  return params;
};
